import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Transcription from './Components/Transcription';
import TermsOfService from './Components/TermsOfService';
import PrivacyPolicy from './Components/PrivacyPolicy';
import SuperuserTranscribeForever from './Components/SuperuserTranscribeForever';
import PaymentSuccessfull from './Components/PaymentSuccessfull';
// import SIpage from './Components/speakeridentify/SIpage';

function App() {
  // 以下代码提交时需要修改为：<Route path="/app" element={
  return (
    <Router>
      <Routes>
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/payment-successful" element={
          <div className="App">
            <PaymentSuccessfull />
          </div>
        } />
        
        <Route path="/appsuperuser" element={
          <div className="App">
            <SuperuserTranscribeForever />
          </div>
        } />

        <Route path="/app" element={
          <div className="App">
            <Transcription />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;